import React, { useState, useEffect } from "react";

const getShopAvatarUrl = (shop) => {
  const avatarUrl = shop?.avatar?.url;

  if (typeof avatarUrl !== "string") {
    return null;
  }

  const normalizedAvatarUrl = avatarUrl.trim();
  return normalizedAvatarUrl || null;
};

const getShopAvatarInitials = (shopName = "") => {
  const initials = String(shopName)
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");

  return initials || "S";
};

const ShopAvatar = ({ shop }) => {
  const [shopAvatar, setShopAvatar] = useState(null);

  useEffect(() => {
    setShopAvatar(getShopAvatarUrl(shop));
  }, [shop]);

  const handleAvatarLoadError = () => {
    setShopAvatar(null);
  };

  return (
    <div className="shop-avatar-wrapper">
      {shopAvatar ? (
        <img
          src={shopAvatar}
          alt={shop.name || "Shop avatar"}
          className="shop-info-sidebar-avatar"
          onError={handleAvatarLoadError}
        />
      ) : (
        <div
          className="shop-info-sidebar-avatar"
          role="img"
          aria-label={`${shop.name || "Shop"} avatar placeholder`}
          style={{
            alignItems: "center",
            background:
              "linear-gradient(135deg, rgba(54, 211, 0, 0.5), rgba(10, 16, 12, 0.9))",
            color: "#ffffff",
            display: "flex",
            fontSize: "1.6rem",
            fontWeight: 700,
            justifyContent: "center",
            letterSpacing: "0.08em",
          }}
        >
          {getShopAvatarInitials(shop?.name)}
        </div>
      )}
    </div>
  );
};

export default ShopAvatar;
